<p class="label">{{ placeholder }}</p>
@if (selectionMode === "date") {
  <input
    type="date"
    [min]="minDate ? formatDate(minDate) : null"
    [max]="maxDate ? formatDate(maxDate) : null"
    (change)="onDateChange($event)"
    [value]="formatDate(selectedDate)"
    class="date-picker"
  />
} @else {
  <div
    class="date-select-container"
    #dropdownTrigger
    (click)="toggleDropdown($event)"
  >
    <img
      src="/assets/images/calendar-icon.svg"
      alt="calendar open icon"
      class="calendar-icon"
    />
    <input
      readonly
      [value]="formatDisplayDate()"
      class="date-input"
      [disabled]="false"
    />
    @if (showDropdown) {
      <div class="dropdown-menu" (click)="$event.stopPropagation()">
        @if (showYearSelection) {
          <div class="year-selection">
            <div class="year-nav">
              <button
                class="nav-btn"
                (click)="changeYearPage(-1)"
                [disabled]="isPrevPageDisabled()"
              >
                <img
                  src="/assets/images/grey-triangle.svg"
                  class="previous-years"
                  alt="Previous year button"
                />
              </button>
              <span class="year-range"
                >{{ yearPageStart }} - {{ yearPageStart + 15 }}</span
              >
              <button
                class="nav-btn"
                (click)="changeYearPage(1)"
                [disabled]="isNextPageDisabled()"
              >
                <img
                  src="/assets/images/grey-triangle.svg"
                  class="next-years"
                  alt="next year button"
                />
              </button>
            </div>
            <div class="year-grid">
              @for (year of getYearsForPage(); track year) {
                <button
                  class="year-btn"
                  [disabled]="isYearDisabled(year)"
                  [class.selected]="isSelectedYear(year)"
                  (click)="selectYear(year, $event)"
                >
                  {{ year }}
                </button>
              }
            </div>
          </div>
        }
        @if (showMonthSelection) {
          <div class="month-selection">
            <div class="month-grid">
              @for (month of months; track month) {
                <button
                  class="month-btn"
                  [disabled]="isMonthDisabled(month)"
                  [class.selected]="isSelectedMonth(month)"
                  (click)="selectMonth(month, $event)"
                >
                  {{ getMonthLabel(month) }}
                </button>
              }
            </div>
          </div>
        }
      </div>
    }
  </div>
}
